// Nav entry of Names, "Meidän nimet" (shell/nav.ts collects every routes/*.nav.ts; `order` places it in the rail, the tabs and Lisää).
import { defineNav } from '../shell/nav-entry';

export const nav = defineNav({ id: 'names', path: '/names', icon: 'names', group: 'together', phone: 'more', order: 1150, load: () => import('./Names') });
